import { message } from 'antd';
import { call, put, takeEvery, all, fork } from 'redux-saga/effects'
import { FETCH_USER_MIPS, FETCH_USER_MIPS_START, FETCH_USER_MIPS_SUCCESS, FETCH_USER_MIPS_ERROR } from '../../actions/admin/userMipActions';
import { getUserMipsAPI } from "../../../services/mips-service";



function* fetchUserMips() {
    try {
        yield put({ type: FETCH_USER_MIPS_START })
        const response = yield call(getUserMipsAPI);
        if (response.success) {
            yield put({ type: FETCH_USER_MIPS_SUCCESS, userMips: response.userMips })
        } else {
            yield put({ type: FETCH_USER_MIPS_ERROR, error: response.error })
            message.error('Failed to fetch sites!');
        }
    } catch (error) {
        yield put({ type: FETCH_USER_MIPS_ERROR, error })
        message.error('Failed to fetch sites!');
    }
}


function* userMipsWatcher() {
    yield takeEvery(FETCH_USER_MIPS, fetchUserMips)
}

export default function* rootSaga() {
    yield all([
        userMipsWatcher(),
    ]);
}